export default function Header() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <h1 className="text-xl md:text-2xl font-bold text-green-800 tracking-wider">
              AGUBEL
            </h1>
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('sobre')}
              className="text-gray-700 hover:text-green-600 transition-colors duration-200 font-medium cursor-pointer"
            >
              Sobre
            </button>
            <button
              onClick={() => scrollToSection('produtos')}
              className="text-gray-700 hover:text-green-600 transition-colors duration-200 font-medium cursor-pointer"
            >
              Produtos
            </button>
            <button
              onClick={() => scrollToSection('historia')}
              className="text-gray-700 hover:text-green-600 transition-colors duration-200 font-medium cursor-pointer"
            >
              História
            </button>
            <button
              onClick={() => scrollToSection('premios')}
              className="text-gray-700 hover:text-green-600 transition-colors duration-200 font-medium cursor-pointer"
            >
              Prêmios
            </button>
            <button
              onClick={() => scrollToSection('impacto')}
              className="text-gray-700 hover:text-green-600 transition-colors duration-200 font-medium cursor-pointer"
            >
              Impacto
            </button>
            <button
              onClick={() => scrollToSection('localizacao')}
              className="text-gray-700 hover:text-green-600 transition-colors duration-200 font-medium cursor-pointer"
            >
              Localização
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="bg-green-600 text-white px-6 py-2 rounded-full hover:bg-green-700 transition-colors duration-200 font-medium cursor-pointer whitespace-nowrap"
            >
              Contato
            </button>
          </nav>
          
          <button
            className="md:hidden text-green-800 cursor-pointer"
            onClick={() => {
              const menu = document.getElementById('mobile-menu');
              if (menu) {
                menu.classList.toggle('hidden');
              }
            }}
          >
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
        
        <div id="mobile-menu" className="hidden md:hidden pb-4">
          <nav className="flex flex-col space-y-3">
            <button
              onClick={() => {
                scrollToSection('sobre');
                document.getElementById('mobile-menu')?.classList.add('hidden');
              }}
              className="text-gray-700 hover:text-green-600 transition-colors duration-200 font-medium text-left cursor-pointer"
            >
              Sobre
            </button>
            <button
              onClick={() => {
                scrollToSection('produtos');
                document.getElementById('mobile-menu')?.classList.add('hidden');
              }}
              className="text-gray-700 hover:text-green-600 transition-colors duration-200 font-medium text-left cursor-pointer"
            >
              Produtos
            </button>
            <button
              onClick={() => {
                scrollToSection('historia');
                document.getElementById('mobile-menu')?.classList.add('hidden');
              }}
              className="text-gray-700 hover:text-green-600 transition-colors duration-200 font-medium text-left cursor-pointer"
            >
              História
            </button>
            <button
              onClick={() => {
                scrollToSection('premios');
                document.getElementById('mobile-menu')?.classList.add('hidden');
              }}
              className="text-gray-700 hover:text-green-600 transition-colors duration-200 font-medium text-left cursor-pointer"
            >
              Prêmios
            </button>
            <button
              onClick={() => {
                scrollToSection('impacto');
                document.getElementById('mobile-menu')?.classList.add('hidden');
              }}
              className="text-gray-700 hover:text-green-600 transition-colors duration-200 font-medium text-left cursor-pointer"
            >
              Impacto
            </button>
            <button
              onClick={() => {
                scrollToSection('localizacao');
                document.getElementById('mobile-menu')?.classList.add('hidden');
              }}
              className="text-gray-700 hover:text-green-600 transition-colors duration-200 font-medium text-left cursor-pointer"
            >
              Localização
            </button>
            <button
              onClick={() => {
                scrollToSection('contato');
                document.getElementById('mobile-menu')?.classList.add('hidden');
              }}
              className="bg-green-600 text-white px-6 py-2 rounded-full hover:bg-green-700 transition-colors duration-200 font-medium text-center cursor-pointer whitespace-nowrap"
            >
              Contato
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
}
